export const blockIconsHardwareKeyboardBackspace = (
	<span className='material-symbols-outlined'>keyboard_backspace</span>
);
